import { useState } from "react";
import { Button } from "../../../design/button";
import { PlaidService } from "../../../services/PlaidService";
import { ArrowPathIcon } from "@heroicons/react/20/solid";
import { useMonthlyExpenseSummary } from "../../../contexts/MonthlyExpenseSummaryContext";

interface RefreshButtonProps {
  type: "statements" | "transactions" | "monthly_expenses";
}

const RefreshButton: React.FC<RefreshButtonProps> = ({ type }) => {
  const { refreshMonthlyExpenseSummary } = useMonthlyExpenseSummary();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const onClick = async () => {
    setIsRefreshing(true);
    try {
      switch (type) {
        case "statements":
          await PlaidService.syncStatements();
          break;
        case "monthly_expenses":
          await refreshMonthlyExpenseSummary();
          break;
        case "transactions":
          await PlaidService.syncTransactions();
          break;
        default:
          throw new Error("Invalid type");
      }
    } catch (error) {
      alert("Error refreshing transactions");
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <Button type="button" onClick={onClick} disabled={isRefreshing}>
      <div className="flex items-center gap-2">
        <ArrowPathIcon className="w-4 h-4" />
        <span className="hidden sm:block">Refresh All</span>
      </div>
    </Button>
  );
};

export default RefreshButton;
